// frontend/src/Advertisement/Admin/ConfirmEmailAds.tsx

import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import HighLogo from "../../HighLogo";
import logo from "../../../assets/logo.png";
import StartFooter from "../StartFooterAd";

const ConfirmEmailAds: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const status = searchParams.get("status");

  const isSuccess = status === "success";

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        background:
          "radial-gradient(circle at top, #020617 0, #000 40%, #020617 100%)",
        color: "#f8fafc",
        fontFamily:
          'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
      }}
    >
      <div style={logoWrap}>
        <button
          type="button"
          onClick={() => navigate("/ads-home")}
          aria-label="Go to advertiser homepage"
          style={logoButton}
        >
          <HighLogo
            src={logo}
            style={{
              width: 190,
              display: "block",
            }}
            padding={0}
          />
        </button>
      </div>

      <main style={mainStyle}>
        <section style={panelStyle}>
          <div style={iconStyle}>
            {isSuccess ? "✓" : "✕"}
          </div>

          <h1 style={titleStyle}>
            {isSuccess
              ? "Email confirmed"
              : "Confirmation failed"}
          </h1>

          <p style={textStyle}>
            {isSuccess
              ? "Your email address has been confirmed. You can now log in and continue your advertiser registration."
              : "This confirmation link is invalid, expired, or has already been used."}
          </p>

          {isSuccess ? (
            <button
              type="button"
              onClick={() => navigate("/ad-login")}
              style={primaryButton}
            >
              Continue to advertiser login
            </button>
          ) : (
            <>
              <button
                type="button"
                onClick={() => navigate("/register")}
                style={primaryButton}
              >
                Return to advertiser registration
              </button>

              <button
                type="button"
                onClick={() => navigate("/ad-login")}
                style={secondaryButton}
              >
                Go to advertiser login
              </button>
            </>
          )}
        </section>
      </main>

      <StartFooter />
    </div>
  );
};

const logoWrap: React.CSSProperties = {
  width: "100%",
  padding: "28px 20px 0",
  boxSizing: "border-box",
};

const logoButton: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  padding: 0,
  margin: 0,
  border: "none",
  background: "transparent",
  cursor: "pointer",
};

const mainStyle: React.CSSProperties = {
  flex: 1,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "48px 20px 72px",
  boxSizing: "border-box",
};

const panelStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: 520,
  padding: "42px 34px",
  borderRadius: 28,
  border: "1px solid rgba(148,163,184,0.2)",
  background: "rgba(15,23,42,0.58)",
  boxShadow: "0 30px 90px rgba(0,0,0,0.55)",
  textAlign: "center",
  boxSizing: "border-box",
};

const iconStyle: React.CSSProperties = {
  width: 72,
  height: 72,
  margin: "0 auto 24px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background:
    "linear-gradient(135deg, rgba(249,115,22,0.24), rgba(250,204,21,0.22))",
  border: "1px solid rgba(250,204,21,0.45)",
  color: "#facc15",
  fontSize: 38,
  fontWeight: 800,
};

const titleStyle: React.CSSProperties = {
  margin: "0 0 16px",
  fontSize: 32,
  fontWeight: 800,
  letterSpacing: -0.8,
  background:
    "linear-gradient(135deg, #f97316 0%, #facc15 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

const textStyle: React.CSSProperties = {
  margin: "0 auto 30px",
  maxWidth: 420,
  color: "#cbd5e1",
  fontSize: 16,
  lineHeight: 1.65,
};

const primaryButton: React.CSSProperties = {
  width: "100%",
  minHeight: 48,
  padding: "12px 20px",
  borderRadius: 999,
  border: "1px solid rgba(250,250,250,0.22)",
  background:
    "linear-gradient(135deg, rgba(249,115,22,0.96), rgba(250,204,21,0.94))",
  color: "#111827",
  fontWeight: 800,
  fontSize: 15,
  cursor: "pointer",
};

const secondaryButton: React.CSSProperties = {
  width: "100%",
  minHeight: 46,
  marginTop: 12,
  padding: "11px 20px",
  borderRadius: 999,
  border: "1px solid rgba(148,163,184,0.25)",
  background: "rgba(15,23,42,0.6)",
  color: "#cbd5e1",
  fontWeight: 700,
  fontSize: 14,
  cursor: "pointer",
};

export default ConfirmEmailAds;